/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import './Accordion.css';
import { CgChevronDown } from 'react-icons/cg';
import { Link } from 'react-router-dom';

const Accordion = ({ data, title }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <section
      onClick={handleOpen}
      className={
        isOpen
          ? 'accordion accordion--expanded footer__section'
          : 'accordion  footer__section'
      }
    >
      <header className="accordion__header">
        <p className="accordion__title footer__title">{title}</p>
        <div className="icon accordion__toggler">
          <CgChevronDown size={20} />
        </div>
      </header>
      <div className="accordion__content footer__content">
        <ul className="list">
          {data.map((item) => (
            <li key={item.link}>
              <Link to="/">{item.link}</Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Accordion;
